import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage33.module.css"
import { Link } from '@mui/material'

export default function LaymanPage33() {
  return (
    <>
      <div className={styles.layman_block_2}>
          <div className={styles.block1_main_wrpr}>
            <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF LEO</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_leo_block_main}>
                <div className={`${styles.leo_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.leo_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/leo_block1_img.webp"
                    /> */}
                    <img className={styles.leo_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_leo/leo_block1_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <div className={styles.yellow_box_heading}>
                        <h1>Leo's Radiance: Embracing the Fixed Fire Within</h1>
                      </div>

                      <p>Leo, a cosmic archetype woven into the fabric of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and Archetypal Astrology, stands as a symbol of Fixed Fire Influence—a regal identification with the lion, poised and magnificent, radiating brilliance into the kingdom of nature.</p>

                      <p>In the cosmic dance of Archetypal influences, Leo beckons us to the ever-present hidden light of the continuously shining Sun. Heraclitus' declaration that the ground state of existence is fire expressed through Logos resonates with the essence of Leo—the fixed fire influence that aligns us with the royal identity of the Lion.</p>

                      <p>Traditionally, the card <span><i>"Strength"</i></span> portrays a lamb tied to the lion's back, embodying the archetype of compassion in a master. However, in the Thoth Tarot, a profound adjustment unveils a deep mystery—the shift to the Arcana <span><i>"Lust"</i></span>. Here, the spiritual, orgasmic will is laid bare, embracing ecstasy, fixed in the evolving life process. This representation captures the true fire burning brightly, wrapped in the experiences of existence and the recognition of beauty. In this regal and confident stance, we embark on passionate desires, engaging in a poetic dance through the journey of life.</p>

                      <p>The Sun's embrace and life-giving relationship with the Earth form the driving force behind all organic life, encouraging growth, evolution, and thriving existence. Seeking the poetry of Pan's flute, mesmerizing the curious, beautiful, timeless nymphs, allows us to truly know Nature. As we orbit the Sun in its golden embrace, Leo becomes the pilot light in the search for meaning, propelling us to new heights of ecstatic experience—the <i>"Drunkenness of Dionysus,"</i> the resurrected and emergent.</p>

                      <p>To awaken Shiva (Consciousness) to the dance of Shakti (Existence) in their fiery eternal embrace is the essence of Leo. On the card <span><i>"Lust,"</i></span> the whore of Babalon, unburdened by conformity, is thrown into ecstasy—lustful, strong, fearlessly riding <i>"The Beast,"</i> representing the wild chaos of our transpersonal becoming.</p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.leo_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/leo_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_leo/leo_block2_img.webp`}/>
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>

                      <p>Working under the influence of Leo invites us to open ourselves to the ever-shining spiritual light hidden within, embracing our life experiences with zeal. It calls for a Lust for Life—a realization of the royal strength within the domain of our transpersonal evolution. Leo encourages us to fully embrace our capacity for endless adventure into the rich tapestry of life experiences, embodying the radiance of the fixed fire within.</p>

                      <div className={styles.yellow_box_heading}>
                        <h1>Astrological Features:</h1>
                      </div>

                      <div className={styles.bullet_cont}>
                        <p><b>Cosmic Archetype:</b> Leo is a significant Cosmic Archetype within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and Archetypal Astrology, embodying the essence of Fixed Fire Influence.</p>

                        <p><b>Fixed Fire Influence:</b> Leo's influence is characterized by Fixed Fire, representing a regal identification with the lion—a poised and magnificent symbol radiating brilliance into the kingdom of nature.</p>

                        <p><b>Royal Identification:</b> Leo's archetype aligns individuals with a royal identification, symbolized by the regal and confident lion, emphasizing a radiant presence within the domain of transpersonal evolution.</p>

                        <p><b>Thoth Tarot - Lust:</b>  In the Thoth Tarot, Leo is associated with the Archana <span><i>"Lust"</i></span>, portraying the spiritual, orgasmic will embracing ecstasy and fixed in the evolving life process.</p>

                        <p><b>Symbolic Strength:</b> Traditionally, Leo is symbolized by the card <span><i>"Strength,"</i></span> featuring a lamb tied to the lion's back—a representation of compassion in a master.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.leo_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img
                      className={styles.leo_img1}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/leo_block3_img.webp"
                    /> */}
                     <img className={styles.leo_img1} src={`${process.env.cloud_url}Layman-Symbolism/layman_page_archetype_of_leo/leo_block3_img.webp`}/>
                  </div>

                  <div className={`${styles.layman_txt_box_wrpr} ${styles.bullet_cont}`}>
                    <div className={styles.layman_txt_box_innr}>

                    <p><b>Sun's Lifegiving Relationship:</b> Leo embodies the Sun's embrace and lifegiving relationship with the Earth, driving all organic life to thrive, grow, and evolve.</p>

                    <p><b>Pilot Light of Meaning:</b> Leo serves as the pilot light in the search for meaning, propelling individuals to new heights of ecstatic experience, akin to the <span><i>"Drunkenness of Dionysus."</i></span></p>

                    <p><b>Poetry of Pan's Flute:</b> Seeking the poetry of Pan's flute, Leo mesmerizes the curious, beautiful, timeless nymphs, allowing individuals to truly know Nature and engage in a poetic dance through life.</p>

                    <p><b>Awakening Shiva and Shakti:</b> Leo invites individuals to awaken Shiva (Consciousness) to the dance of Shakti (Existence) in their fiery eternal embrace, symbolized by the spiritual and energetic dynamics on the card <span><i>"Lust."</i></span></p>

                    <p><b>Wild Chaos of Transpersonal Becoming:</b> <span><i>"Lust"</i></span> depicts the whore of Babalon, unburdened by conformity, thrown into ecstasy—symbolizing the wild chaos of transpersonal becoming.</p>

                    <p><b>Zeal for Life:</b> Working under the influence of Leo encourages individuals to open themselves to the ever-shining spiritual light within, embracing life experiences with a Lust for Life and Zeal.</p>

                    <p><b>Endless Adventure:</b> Leo embodies the capacity for endless adventure into the rich tapestry of life experiences, encouraging individuals to fully embrace their transpersonal evolution with confidence and radiance.</p>
                    </div>
                  </div>
                </div>

                <div className={styles.green_sec_cmn_main_wrp}>
                 
                    <Link href="/rota-the-wheel">
                      <div className={styles.green_sec_cmn_sub_wrp}>
                        <h1>The Astrological Tarot association for Leo is The <br/>Strength. See our alchemical ROTA here.</h1>
                      </div>
                    </Link>
                  
                </div>
              </div>
            </div>

            {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/layman_page27_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/layman_page27_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/layman_page27_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_archetype_of_leo/layman_page27_block4_demo_img.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
            </div> */}
            </div>
          </div>
        </div>
    </>
  )
}
